import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  palette: {
    primary: {
      main: '#561651',
    },
    secondary: {
      main: '#D09F53',
    },
    error: {
      main: '#c40505',
    },
    text: {
      primary: '#561651',
      secondary: '#FFF',
      action: '#D09F53',
      accent: '#001a41', //Success Wrapper
    },
    background: '#561651',
    navBarBackground: '#FFF',
    custom: {
      smoke: '#C8C8C8',
      snow: '#FAFAFA',
    },
  },
  typography: {
    useNextVariants: true,
    textTransform: 'capitalize',
    fontFamily: 'Cambay, sans-serif',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFF',
          color: '#561651',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: '#561651',
          fontFamily: 'Cambay, sans-serif',
          fontWeight: 400,
          textTransform: 'capitalize',
        },
        h5: {
          color: '#561651',
          fontFamily: 'Cambay, sans-serif',
          fontWeight: 400,
          textTransform: 'capitalize',
        },
        h2: {
          fontFamily: 'Cambay, sans-serif',
          fontWeight: 400,
          textTransform: 'capitalize',
          fontSize: '1rem',
        },
        h4: {
          color: '#561651',
          fontFamily: 'Cambay, sans-serif',
          fontWeight: 400,
          textTransform: 'capitalize',
        },
        h1: {
          fontFamily: 'Cambay, sans-serif',
          fontWeight: 200,
          textTransform: 'capitalize',
        },
        h6: {
          fontFamily: 'Cambay, sans-serif',
          fontWeight: 400,
          textTransform: 'capitalize',
        },
        h3: {
          fontFamily: 'Cambay, sans-serif',
          fontWeight: 400,
          textTransform: 'capitalize',
        },
      },
    },
    MuiDialogContentText: {
      styleOverrides: {
        root: {
          color: '#561651',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          color: '#001a41',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: '#001a41',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#001a41',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: '#561651',
          color: '#FFF',
        },
        containedSecondary: {
          backgroundColor: '#D09F53',
          color: '#FFF',
        },
      },
    },
  },
})

export const popaTheme = createTheme({
  palette: {
    primary: {
      main: '#34343c',
    },
    secondary: {
      main: '#002243',
    },
    error: {
      main: '#A00',
    },
    text: {
      primary: '#002243',
      secondary: '#FFF',
      action: '#80b0dd',
      accent: '#001a41', //Success Wrapper
    },
    background: '#01407A',
    navBarBackground: '#FFF',
  },
  typography: {
    useNextVariants: true,
    textTransform: 'capitalize',
    fontFamily: 'Roboto, sans-serif',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  overrides: {
    MuiPaper: {
      root: {
        backgroundColor: '#F7F8FA',
        color: '#34343c',
      },
    },
    MuiTypography: {
      root: {
        color: '#34343c',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 400,
        textTransform: 'capitalize',
      },
      h5: {
        color: '#34343c',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 400,
        textTransform: 'capitalize',
      },
      h2: {
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 400,
        textTransform: 'capitalize',
        fontSize: '1rem',
      },
      h4: {
        color: '#34343c',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 400,
        textTransform: 'capitalize',
      },
      h1: {
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 200,
        textTransform: 'capitalize',
      },
      h6: {
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 400,
        textTransform: 'capitalize',
      },
      h3: {
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 400,
        textTransform: 'capitalize',
      },
    },
    MuiDialogContentText: {
      root: {
        color: '#34343c',
      },
    },
    MuiTextField: {
      root: {
        color: '#002243',
      },
    },
    MuiFormLabel: {
      root: {
        color: '#002243',
      },
    },
    MuiCheckbox: {
      root: {
        color: '#9ECB3A',
      },
    },
    MuiButton: {
      containedPrimary: {
        backgroundColor: '#80b0dd',
        color: '#FFF',
      },
      containedSecondary: {
        backgroundColor: '#80b0dd',
        color: '#FFF',
      },
    },
  },
})

export const cjptheme = createTheme({
  palette: {
    primary: {
      main: '#34343c',
    },
    secondary: {
      main: '#2DBCD4',
    },
    error: {
      main: '#A00',
    },
    text: {
      primary: '#34343c',
      secondary: '#FFF',
      action: '#2DBCD4',
      accent: '#001a41',
    },
    // background: '#C5C5C4'
    background: '#C5C5C4',
    navBarBackground: '#FFF',
  },
  typography: {
    useNextVariants: true,
    textTransform: 'capitalize',
    fontFamily: 'Roboto, sans-serif',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  overrides: {
    MuiPaper: {
      root: {
        backgroundColor: '#F7F8FA',
        color: '#34343c',
      },
    },
    MuiTypography: {
      root: {
        color: '#34343c',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 400,
        textTransform: 'capitalize',
      },
      h5: {
        color: '#34343c',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 400,
        textTransform: 'capitalize',
      },
      h2: {
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 400,
        textTransform: 'capitalize',
        fontSize: '1rem',
      },
      h4: {
        color: '#34343c',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 400,
        textTransform: 'capitalize',
      },
      h1: {
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 200,
        textTransform: 'capitalize',
      },
      h6: {
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 400,
        textTransform: 'capitalize',
      },
      h3: {
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 400,
        textTransform: 'capitalize',
      },
    },
    MuiDialogContentText: {
      root: {
        color: '#34343c',
      },
    },
    MuiTextField: {
      root: {
        color: '#2DBCD4',
      },
    },
    MuiFormLabel: {
      root: {
        color: '#2DBCD4',
      },
    },
    MuiCheckbox: {
      root: {
        color: '#9ECB3A',
      },
    },
    MuiButton: {
      containedPrimary: {
        backgroundColor: '#2DBCD4',
        color: '#FFF',
      },
      containedSecondary: {
        backgroundColor: '#34343c',
        color: '#FFF',
      },
    },
  },
})

export const fltplanTheme = createTheme({
  breakpoints: {
   values: {
    lg: 1280,
    md: 960,
    sm: 600,
    xl: 1920,
    xs: 0
   }
  },
  components: {
   MuiButton: {
    styleOverrides: {
     containedPrimary: {
      backgroundColor: "#01407A",
      color: "#FFF"
     },
     containedSecondary: {
      backgroundColor: "#01407A",
      color: "#FFF"
     }
    }
   },
   MuiCheckbox: {
    styleOverries: {
     root: {
      color: "#9ECB3A"
     }
    }
   },
   MuiDialogContentText: {
    styleOverrides: {
     root: {
      color: "#042856"
     }
    }
   },
   MuiFormLabel: {
    styleOverrides: {
     root: {
      color: "#1F7EE5"
     }
    }
   },
   MuiPaper: {
    styleOverrides: {
     root: {
      backgroundColor: "#F7F8FA",
      color: "#042856"
     }
    }
   },
   MuiTextField: {
    styleOverrides: {
     root: {
      color: "#1F7EE5"
     }
    }
   },
   MuiTypography: {
    styleOverrides: {
     h1: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 200
     },
     h2: {
      fontFamily: "Roboto, sans-serif",
      fontSize: "1rem",
      fontWeight: 400
     },
     h3: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400
     },
     h4: {
      color: "#042856",
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400
     },
     h5: {
      color: "#FFF",
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400
     },
     h6: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400
     },
     root: {
      color: "#042856",
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400
     }
    }
   }
  },
  palette: {
   background: "#01407A",
   error: {
    main: "#C40505"
   },
   navBarBackground: "#042856",
   primary: {
    main: "#042856"
   },
   secondary: {
    main: "#1F7EE5"
   },
   text: {
    accent: "#001a41",
    action: "#9ECB3A",
    primary: "#042856",
    secondary: "#FFF",
    white: "#FFF"
   }
  },
  typography: {
   fontFamily: "Roboto, sans-serif",
   textTransform: "capitalize",
   useNextVariants: true
  }
 },
)

export const themesByClient = {
  cst: theme,
  fltplan: fltplanTheme,
  popa: popaTheme,
  cjp: cjptheme,
}
